import { useState } from 'react';

export const useServiceRequest = data => {
	const [inputs, setInputs] = useState(data);
	const change = event => {
		const value = event.target.value;
		setInputs(inputs => ({
			...inputs,
			[event.target.name]: value,
		}));
	};
	return {
		change,
		inputs,
	};
};
